import React from "react";

function CloseIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      {...props}
    >
      <path
        fill="#969799"
        d="M10.5 8.996l7.19-7.188a1.06 1.06 0 10-1.5-1.5L9 7.503 1.808.31a1.06 1.06 0 10-1.5 1.5L7.5 8.996l-7.19 7.2a1.06 1.06 0 101.5 1.5l7.19-7.2 7.192 7.192a1.06 1.06 0 001.5-1.5z"
      />
    </svg>
  );
}

export default CloseIcon;
